import { z } from 'zod';
import { isCustomFieldValueEmpty } from '@/utils/customFieldValidation';
import type { SharedCustomField } from '@/types/serializers';

// customFields を受け取り、必須カスタムフィールドの検証を含むスキーマを動的に生成する。
// 静的スキーマだと is_required の情報を持てず必須チェックができないため、企業新規作成
// （createCompaniesCreateSchema）と同じく superRefine で field_id 単位のエラーを付与する。
export const createCandidatesProfileAddSchema = (customFields: SharedCustomField[] = []) => {
  const requiredFields = customFields.filter((field) => field.is_required);

  return z.object({
    name: z.string().min(1, '＊氏名は必須項目です。入力してください。'),
    organizationUserIds: z.array(z.number()).optional(),
    customData: z
      .record(z.string(), z.union([z.string(), z.number(), z.array(z.string())]).optional())
      .superRefine((data, ctx) => {
        requiredFields.forEach((field) => {
          if (isCustomFieldValueEmpty(field, data?.[String(field.id)])) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: [String(field.id)],
              message: `＊${field.name}は必須項目です。入力してください。`,
            });
          }
        });
      }),
    /** 書類から作成モード: 解析済みblobのsigned_idリスト。保存時にdocument_filesとしてアタッチ */
    documentBlobSignedIds: z.array(z.string()).optional(),
  });
};

export type CandidatesProfileAddSchema = z.infer<
  ReturnType<typeof createCandidatesProfileAddSchema>
>;
